var exports = {
  "n": "x31de4314--72bd3f--link",
};

module.exports = exports;
